
const EVENTS = {
    ASPECT_RATIO_CHANGE: "lesson:aspect_ratio:change",
    VIDEO_URL_CHANGE: "lesson:video_url:change",
    BANNER_CHANGE: "lesson:banner:change",
    AVAILABILITY_CHANGE: "lesson:availability:change",
};

export default EVENTS
